import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { CaseState } from 'dashboard/models/case-template';
import Sticker from 'design-system/components/Sticker';

const StickerContainer = styled('div')`
  display: grid;
  width: fit-content;
  align-items: center;

  gap: ${Spacing[2]};
`;

interface CaseStatusStickerProps {
  caseState: Partial<CaseState>;
  disabled?: boolean;
  'data-test'?: string;
}

const CaseStatusSticker = (props: CaseStatusStickerProps) => {
  const caseState = props.caseState;
  const disabled = props.disabled ?? false;

  let variant = caseState.color;

  // NB: The 'red' sticker corresponds to dark red which is the Warning sticker used on Dashboard.
  // What we actually want is the 'pink' sticker.
  if (caseState.color === 'red') {
    variant = 'pink';
  }

  return (
    <StickerContainer data-test={props['data-test']}>
      <Sticker variant={variant} disabled={disabled}>
        {caseState.name}
      </Sticker>
    </StickerContainer>
  );
};

export default CaseStatusSticker;
